import React from 'react'

import { SearchState } from '@features/search'
import SearchStateManager from '@managers/SearchableSelectList'

interface ITheme {
  menu?: string
  menu_open?: string
  option?: string
  option_selected?: string
  [key: string]: ITheme[keyof ITheme]
}
interface IProps {
  autoComplete?: string
  id: string
  loader?: any
  theme: ITheme
  searchForArea?: (v: any) => Promise<any>
}

export default class AreaSearchInput extends SearchStateManager<IProps> {
  constructor(props: IProps) {
    super(props)
    this.searchForLocation = this.searchForLocation.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  searchForLocation(_: string, value: string) {
    const { name, searchForArea, setSearchState } = this.props
    if (searchForArea) {
      if (value.length > 2) {
        setSearchState(name, SearchState.SEARCHING)
        searchForArea(value).then(() => {
          setSearchState(name, SearchState.COMPLETE)
        })
      }
    }
  }

  handleChange(e: any) {
    super.handleChange(e)
    const { name } = this.props
    const { value } = e.target
    this.searchForLocation(name, value)
  }

  render() {
    const {
      autoComplete,
      id,
      name,
      className,
      loader,
      theme,
      menuOpen,
      searchValue,
      searchState,
      matchingOptions,
      highlightedIndex
    } = this.props

    return (
      <div>
        <input
          autoComplete={autoComplete}
          id={id}
          name={name}
          value={searchValue || ''}
          placeholder={this.props.placeholder}
          className={className}
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
        />

        <ul className={menuOpen ? theme.menu_open : theme.menu}>
          {matchingOptions.map(({ name }, index) => {
            let isHighlighted = highlightedIndex === index
            let content = name

            return (
              <li
                key={name}
                data-index={index}
                className={`${theme.option}${isHighlighted ? ' is-highlighted' : ''}`}
                onClick={() => this.handleClick(index)}
                onMouseOver={() => this.handleHover(index)}
              >
                {content}
              </li>
            )
          })}
          {searchState === 'SEARCHING' && loader}
        </ul>
      </div>
    )
  }
}
